/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import { ModificationTrackingForm } from 'core/forms';

import { Typo } from 'uikit/content';
import { Loading } from 'uikit/loaders';

import styles from '../styles/videosAdminTopicPropertiesForm.module.scss';

const VideosAdminTopicPropertiesForm = ({
  shouldShowLoading,
  model,
  onError,
  onSaveClick,
  onCancelClick,
  onFormUpdate,
  schema,
  title,
}) => (
  <section className={styles.element}>
    <div className={styles.titleWrap}>
      <Typo element="h2" variant="h5" modifier="semi">
        {title}
      </Typo>
    </div>
    {(!shouldShowLoading) && (
      <ModificationTrackingForm
        onSaveClick={onSaveClick}
        onCancelClick={(args) => onCancelClick({ ...args, schema })}
        onFormUpdate={onFormUpdate}
        onError={onError}
        model={model}
        schema={schema}
      />
    )}
    {(shouldShowLoading) && (
      <Loading />
    )}
  </section>
);

VideosAdminTopicPropertiesForm.defaultProps = {
  title: '',
  shouldShowLoading: false,
  onError: () => {},
  onSaveClick: () => {},

};

VideosAdminTopicPropertiesForm.propTypes = {
  shouldShowLoading: PropTypes.bool,
  model: PropTypes.objectOf(PropTypes.any).isRequired,
  schema: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  onError: PropTypes.func,
  onSaveClick: PropTypes.func,
  title: PropTypes.string,
};

export default React.memo(VideosAdminTopicPropertiesForm);
